// Academic year / semester enums.
//
// After the api-dev2 backend normalization, the API returns academic year and
// semester as NUMERIC enums (e.g. year 3 = Junior) instead of strings like
// "Junior". Use these helpers wherever the FE reads/displays year or semester
// so a number is handled correctly instead of being treated as a string.

export const AcademicYearEnum = {
  Unknown: 0,
  Freshman: 1,
  Sophomore: 2,
  Junior: 3,
  Senior: 4,
}

export const ACADEMIC_YEAR_LABELS = {
  0: 'Unknown',
  1: 'Freshman',
  2: 'Sophomore',
  3: 'Junior',
  4: 'Senior',
}

// Accepts the numeric enum (or a numeric string) and returns the display label.
export const academicYearLabel = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return ACADEMIC_YEAR_LABELS[Number(value)] || ''
}

export const SemesterEnum = {
  Unknown: 0,
  Fall: 1,
  Spring: 2,
}

export const SEMESTER_LABELS = {
  0: 'Unknown',
  1: 'Fall',
  2: 'Spring',
}

export const semesterLabel = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return SEMESTER_LABELS[Number(value)] || ''
}

export const AcademicExamTypeEnum = {
  Unknown: 0,
  Assignments: 1,
  Quiz: 2,
  Project: 4,
}

export const EXAM_TYPE_LABELS = {
  0: 'Unknown',
  1: 'Assignments',
  2: 'Quiz',
  4: 'Project',
}

export const examTypeLabel = (value) => {
  if (value === null || value === undefined || value === '') return ''
  return EXAM_TYPE_LABELS[Number(value)] || ''
}
